import { MedosClient } from "../../client/MedosClient";
import { ENDPOINTS } from "../../constants/endpoints";
import { generateIdempotencyKey } from "../../utils/idempotencyKey";
import { normalizeAppointment } from "./types";
export const PortalAppointmentService = {
    async listMine(params) {
        const client = await MedosClient.ensureInitialized();
        const res = await client.get(ENDPOINTS.portal.myAppointments, {
            params: {
                patientId: params.patientId ?? undefined,
                startDate: params.startDate,
                endDate: params.endDate,
            },
        });
        const raw = res.data;
        const rows = raw?.data ?? raw;
        return Array.isArray(rows) ? rows.map(normalizeAppointment) : [];
    },
    async cancel(params) {
        const client = await MedosClient.ensureInitialized();
        const res = await client.post(ENDPOINTS.portal.cancelAppointment(params.appointmentId), { cancellationReason: params.cancellationReason }, {
            headers: {
                "Idempotency-Key": params.idempotencyKey ?? generateIdempotencyKey(),
            },
        });
        return res.data?.data ?? res.data;
    },
    async selfAttest(params) {
        const client = await MedosClient.ensureInitialized();
        const res = await client.patch(ENDPOINTS.portal.appointmentStatus(params.appointmentId), { status: params.status }, {
            headers: {
                "Idempotency-Key": params.idempotencyKey ?? generateIdempotencyKey(),
            },
        });
        return res.data?.data ?? res.data;
    },
    async reschedule(params) {
        const client = await MedosClient.ensureInitialized();
        const res = await client.post(ENDPOINTS.appointments.reschedule(params.appointmentId), { ...params.body, doctorId: params.doctorId, addressId: params.addressId }, {
            headers: {
                "Idempotency-Key": params.idempotencyKey ?? generateIdempotencyKey(),
            },
        });
        return res.data?.data ?? res.data;
    },
};
